export const OfferFileSignStatus = {
    NOT_SIGNED: "NOT_SIGNED",
    SIGNED: "SIGNED",
    WRONG_SIGN: "WRONG_SIGN",
    SIGNATURE_FILE: "SIGNATURE_FILE"
}